const formSend = (form, btn) => {
    if (form) {

        form.addEventListener('submit', (event) => {
            let form = event.target;
            let btnSendFormBlog = btn;
            event.preventDefault();
            btnSendFormBlog.attr('disabled', 'true');
            return false;
        });

    }
}
const returnTemplateWp = () => {
    return template;
}
sanitize = function(input) {
    var output = input.replace(/<script[^>]*?>.*?<\/script>/gi, '').
                 replace(/<[\/\!]*?[^<>]*?>/gi, '').
                 replace(/<style[^>]*?>.*?<\/style>/gi, '').
                 replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '').
       replace(/&nbsp;/g, '');
    return output;
};
const loadDom = () => {
    let formDown = document.querySelector('#form_download');
    let formBlog = document.querySelector('#blog-form');
    let formModal = document.querySelector('#form-modal');
    let formWork = document.querySelector('#form-work');
    let formCompany = document.querySelector('#form-company');
    let btnDown = $('#submit-form-mdc');
    let btnblog = $('#sendBlogForm');
    let btnDModal = $('#sendModal');
    let btnWork = $('#sendWork');
    let btnFormCompany = $('#sendFormCompany');
    formSend(formDown, btnDown);
    formSend(formBlog, btnblog); 
    formSend(formModal, btnDModal);
    formSend(formWork, btnWork);
    formSend(formCompany, btnFormCompany);
    document.addEventListener('wpcf7submit', function (event, template) {
        let idForm = parseInt(event.detail.contactFormId)
        let fetchApiMailchimp = async (url, headInit) => {
            const response = await fetch(url, headInit);
            return response.json();
        };
        switch (idForm) {
            case 5890: // send form redirect gracias
                if (event.detail.status === 'mail_sent') {
                    // obtendremos el permalink de page gracias
                    template = returnTemplateWp();
                    //integration api mailchimp
                    let checkbox = document.querySelector('#checkbox-subscription').checked;
                    if (checkbox) {
                        let data = new FormData();
                        data.append('firstname', sanitize(document.querySelector('#dfirstname').value));
                        // data.append('firstname', document.querySelector('#dfirstname').value);
                        data.append('lastname', sanitize(document.querySelector('#dlastname').value));
                        data.append('email', document.querySelector('#demail').value);
                        data.append('phone', document.querySelector('#dphone') ? document.querySelector('#dphone').value : 'NA');
                        data.append('cargotitle', document.querySelector('#dcargo').value);
                        data.append('cargoarea', document.querySelector('#dcargo').dataset.mdc_value);
                        data.append('mckey', document.querySelector('#MCkey').value);
                        data.append('lastdownloadfile', document.querySelector('#last_download_file').value);
                        data.append('utmsource', document.querySelector('#utm_source').value);
                        data.append('utmmedium', document.querySelector('#utm_medium').value);
                        data.append('utmcampaign', document.querySelector('#utm_campaign').value);
                        const urlB = template.mcint
                        const header = {
                            method: 'POST',
                            //headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryeBs6lzForh8BEn4Y' },
                            mode: 'cors',
                            cache: 'default',
                            redirect: 'follow',
                            referrerPolicy: 'no-referrer',
                            body: data
                        };
                        fetchApiMailchimp(urlB, header)
                            .then(response => {
                                if (response.status !== 400) {
                                    //console.log(response);
                                    let pageType = document.querySelector('#page-type').value;
                                    dataLayer.push({
                                        'pageType': pageType,
                                        'formName': 'Form contacto empresa',
                                        'event': 'Lead Confirmed'
                                    });
                                } else {
                                    //console.log(response);
                                }
                            })
                        //return false;
                    }
                    let client = {
                        'name': document.querySelector('#dfirstname').value,
                        'mail': document.querySelector('#demail').value,
                        'subject': 'Tu descarga de Fundación Con Trabajo'
                    }
                    const data = {
                        'client': client,
                        'originid': event.detail.containerPostId,
                        'security': template.thank_you.nonce,
                        'action': template.thank_you.action
                    };
                    let url = template.fixu.url;
                    $.post(url, data, (response) => {
                        if (response.permalink === '#error-mail') {
                            $('.fusion-alert').text('Ocurrió un error al intentar enviarte tu descarga...');
                        } else {
                            window.location.assign(response.permalink);
                            setTimeout(() => {
                                $('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                                $('.mdc-select').find('#slct-cargo-text').text('');
                                $('.mdc-text-field').find('input').val('');
                                $('.fusion-slider-loading').attr('style', 'display:none;')
                                $('.fusion-alert').attr('style', 'display:none;');
                            }, 1500)
                            setTimeout(() => {
                                $('.fusion-alert').attr('style', 'display:none;');
                            }, 6500)
                        }
                    }, 'json');

                } else {
                    let btnSendFormBlog = $('#submit-form-mdc');
                    btnSendFormBlog.removeAttr('disabled');

                    let inputInvalidResponse = event.detail.apiResponse.invalid_fields;
                    if (event.detmysqail.apiResponse.status !== 'spam' && inputInvalidResponse) {
                        for (const input of inputInvalidResponse) {
                            let inputElement = document.querySelector(`#${input.idref}`),
                                inputElementHelperText = document.querySelector(`#${input.idref.substring(1)}-helper-text`);

                            inputElement.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            inputElement.focus();
                            inputElementHelperText.innerText = input.message;
                        }
                        // select
                        let valueSlct = document.querySelectorAll('.mdc-select__selected-text');
                        for (const element of valueSlct) {
                            if (element.innerText === '') {
                                let id = element.dataset.id,
                                    message = 'El campo es obligatorio';
                                element.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                                element.parentNode.parentNode.nextElementSibling.firstElementChild.innerText = message;
                            }
                        }
                        setTimeout(() => {
                            $('.fusion-alert').attr('style', 'display:none;');
                        }, 8500)
                        setTimeout(() => {
                            $('.fusion-slider-loading').attr('style', 'display:none;')
                        }, 1500)
                    } else {

                        setTimeout(() => {
                            $('.fusion-alert').attr('style', 'display:none;');
                        }, 8500)
                        setTimeout(() => {
                            $('.fusion-slider-loading').attr('style', 'display:none;')
                        }, 1500)

                    }
                }
                break;
            case 5889: // form blog
                if (event.detail.status === 'mail_sent') {

                    template = returnTemplateWp();
                    let data = new FormData();
                    data.append('firstname', document.querySelector('#dfirstname').value);
                    data.append('lastname', document.querySelector('#dlastname').value);
                    data.append('email', document.querySelector('#demail').value);
                    data.append('phone', document.querySelector('#dphone') ? document.querySelector('#dphone').value : 'NA');
                    data.append('cargotitle', document.querySelector('#dcargo').value);
                    data.append('cargoarea', document.querySelector('#dcargo').dataset.mdc_value);
                    data.append('mckey', document.querySelector('#MCkey').value);
                    data.append('utmsource', document.querySelector('#utm_source').value);
                    data.append('utmmedium', document.querySelector('#utm_medium').value);
                    data.append('utmcampaign', document.querySelector('#utm_campaign').value);
                    data.append('utmextra', document.querySelector('#utm_campaign_info_b').value);
                    const urlB = template.mcint
                    const headerB = {
                        method: 'POST',
                        //headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryeBs6lzForh8BEn4Y' },
                        mode: 'cors',
                        cache: 'default',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: data
                    };
                    fetchApiMailchimp(urlB, headerB)
                        .then(response => {
                            if (response.status !== 400) {
                                //console.log(response);
                                let pageType = document.querySelector('#page-type').value;
                                dataLayer.push({
                                    'pageType': pageType,
                                    'formName': 'Form contacto empresa',
                                    'event': 'Lead Confirmed'
                                });
                            } else {
                                //console.log(response);
                            }
                        })
                    //return false;

                    let slctCargo = $('#slct-cargo-text'),
                        slctNw = $('#slct-nw-text'),
                        textArea = $('.mdc-text-field--textarea');
                    slctCargo.text('');
                    slctNw.text('');
                    slctCargo.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    slctNw.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    textArea.find('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    $('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                        $('.fusion-alert').remove();
                        
                        $('.modal-company').remove();
                        $('#gracia-2').attr('style', 'display:block;');
                        $('#sendBlogForm').removeAttr('disabled');

                    }, 3500);
                } else {
                    event.preventDefault();
                    let btnSendFormBlog = $('#sendBlogForm');
                    btnSendFormBlog.removeAttr('disabled');
                    let inputInvalidResponse = event.detail.apiResponse.invalid_fields;
                    
                    if(inputInvalidResponse != null) {
                        for (const input of inputInvalidResponse) {
                            let inputElement = document.querySelector(`#${input.idref}`),
                                inputElementHelperText = document.querySelector(`#${input.idref.substring(1)}-helper-text`);

                            inputElement.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            inputElement.focus();
                            inputElementHelperText.innerText = input.message;
                        }
                        // select
                        let valueSlct = document.querySelectorAll('.mdc-select__selected-text');
                        for (const element of valueSlct) {
                            if (element.innerText === '') {
                                let id = element.dataset.id,
                                    message = 'El campo es obligatorio';
                                element.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                                element.parentNode.parentNode.nextElementSibling.firstElementChild.innerText = message;
                            }
                        }
                    }
                    setTimeout(() => {
                        $('.fusion-alert').remove();
                    }, 1500);
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                    }, 8500);
                    return false;
                }
                break;
            case 7613: // form contact trabajadores
                if (event.detail.status === 'mail_sent') {
                    template = returnTemplateWp();
                    let data = new FormData();
                    let lastname = `${document.querySelector('#work-lastname-p').value} ${document.querySelector('#work-lastname-m').value}`
                    data.append('firstname', document.querySelector('#work-firstname').value);
                    data.append('lastname', lastname);
                    data.append('email', document.querySelector('#work-email').value);
                    data.append('phone', document.querySelector('#work-phone') ? document.querySelector('#work-phone').value : 'NA');
                    data.append('phoneoptional', document.querySelector('#work-phone-2') ? document.querySelector('#work-phone-2').value : 'NA');
                    data.append('cargotitle', document.querySelector('#region_e').value);
                    //data.append('cargoarea', document.querySelector('#dcargo').dataset.mdc_value);
                    data.append('mckey', document.querySelector('#MCkey_e').value);
                    data.append('utmsource', document.querySelector('#utm_source_e').value);
                    data.append('utmmedium', document.querySelector('#utm_medium_e').value);
                    data.append('utmcampaign', document.querySelector('#utm_campaign_e').value);
                    data.append('utmextra', document.querySelector('#utm_campaign_info_e').value);
                    const urlB = template.mcint
                    const headerB = {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'default',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: data
                    };
                    fetchApiMailchimp(urlB, headerB)
                        .then(response => {
                            if (response.status !== 400) {
                                //console.log(response);
                                let pageType = document.querySelector('#page-type').value;
                                dataLayer.push({
                                    'pageType': pageType,
                                    'formName': 'Form contacto empresa',
                                    'event': 'Lead Confirmed'
                                });
                            } else {
                                //console.log(response);
                            }
                        })

                    let slctRegion = $('#slct-region'),
                        slctComuna = $('#slct-comuna'),
                        textArea = $('.mdc-text-field--textarea');
                    slctRegion.text('');
                    slctComuna.text('');
                    slctRegion.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    slctComuna.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    textArea.find('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    $('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    $(".fusion-alert").css("color", "#1F8097");
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                        $('#form-work').find('.fusion-alert').attr('style', 'display:none;');
                    }, 3500);
                } else {
                    event.preventDefault();
                    let btnSendFormBlog = $('#sendWork');
                    btnSendFormBlog.removeAttr('disabled');
                    let inputInvalidResponse = event.detail.apiResponse.invalid_fields;
                    
                    if(inputInvalidResponse != null) {
                        for (const input of inputInvalidResponse) {
                            let inputElement = document.querySelector(`#${input.idref}`),
                                inputElementHelperText = $(`#${input.idref}~.mdc-text-field-helper-line`);

                            inputElement.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            inputElement.focus();
                            inputElementHelperText.innerText = input.message;
                        }
                        // select
                        let valueSlct = document.querySelectorAll('.mdc-select__selected-text-work');
                        for (const element of valueSlct) {
                            if (element.innerText === '') {
                                let id = element.dataset.id,
                                    message = 'El campo es obligatorio';
                                    
                                element.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                                element.parentNode.parentNode.nextElementSibling.firstElementChild.innerText = message;
                            }
                        }
                    }
                    
                    $(".fusion-alert").css("color", "#D7602C");
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                    }, 3500);
                    setTimeout(() => {
                        $('#form-work').find('.fusion-alert').attr('style', 'display:none;');
                    }, 8500);
                    return false;
                }
                break;
            case 7612: // form contact modal
                if (event.detail.status === 'mail_sent') {

                    template = returnTemplateWp();
                    let data = new FormData();
                    data.append('firstname', document.querySelector('#modal-firstname').value);
                    data.append('lastname', document.querySelector('#modal-lastname').value);
                    data.append('email', document.querySelector('#modal-email').value);
                    data.append('phone', document.querySelector('#modal-phone') ? document.querySelector('#modal-phone').value : 'NA');
                    data.append('mckey', document.querySelector('#MCkey_m').value);
                    data.append('utmsource', document.querySelector('#utm_source_m').value);
                    data.append('utmmedium', document.querySelector('#utm_medium_m').value);
                    data.append('utmcampaign', document.querySelector('#utm_campaign_m').value);
                    data.append('utmextra', document.querySelector('#utm_campaign_info_m').value);
                    const urlM = template.mcint
                    const headerM = {
                        method: 'POST',
                        //headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryeBs6lzForh8BEn4Y' },
                        mode: 'cors',
                        cache: 'default',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: data
                    };
                    fetchApiMailchimp(urlM, headerM)
                        .then(response => {
                            if (response.status !== 400) {
                                //console.log(response);
                                let pageType = document.querySelector('#page-type').value;
                                dataLayer.push({
                                    'pageType': pageType,
                                    'formName': 'Form contacto empresa',
                                    'event': 'Lead Confirmed'
                                });
                            } else {
                                //console.log(response);
                            }
                        }) 

                    $('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    $('#form-modal').find('.fusion-alert').attr('style', 'display:none;');
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                        $('.contact-modal').find('#b-cerrar').attr('style', 'display:none;');
                        $('#form-modal').attr('style', 'display:none;');
                        $('#gracia').attr('style', 'display:block;');
                        $('.contact-modal').on('hidden.bs.modal', function (event) {                            
                            $('.contact-modal').find('#b-cerrar').attr('style', 'display:block;');
                            $('#form-modal').attr('style', 'display:block;');
                            $('#gracia').attr('style', 'display:none;');
                            $('#form-modal').find('.fusion-alert').attr('style', 'display:none;');
                        })
                    }, 3500);


                } else {
                    event.preventDefault();
                    let btnSendFormBlog = $('#sendModal');
                    btnSendFormBlog.removeAttr('disabled');
                    let inputInvalidResponse = event.detail.apiResponse.invalid_fields;
                    if(inputInvalidResponse != null) {
                        for (const input of inputInvalidResponse) {
                            let inputElement = document.querySelector(`#${input.idref}`),
                                inputElementHelperText = document.querySelector(`#${input.idref}-helper-text`);
    
                            inputElement.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            if (input.idref == 'modal-textarea-message') {
                                inputElement.parentNode.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            }
                            inputElementHelperText.innerText = input.message;
                            inputElement.focus();
                        }
                    }
                    // select
                    $(".fusion-alert").css("color", "#D7602C");
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                    }, 3500);
                    setTimeout(() => {
                        $('#form-modal').find('.fusion-alert').attr('style', 'display:none;');
                    }, 8500);
                    return false;
                }
                break;
            case 7611: // form contact modal empresa
            
                if (event.detail.status === 'mail_sent') {
                    template = returnTemplateWp();
                    let data = new FormData();
                    data.append('firstname', document.querySelector('#company-firstname').value);
                    data.append('lastname', document.querySelector('#company-lastname').value);
                    data.append('email', document.querySelector('#company-email').value);
                    data.append('phone', document.querySelector('#company-phone') ? document.querySelector('#company-phone').value : 'NA');
                    data.append('cargotitle', document.querySelector('#dcargo-company').value);
                    data.append('cargoarea', document.querySelector('#dcargo-company').dataset.mdc_value);
                    data.append('mckey', document.querySelector('#MCkeyempresa_company').value);
                    data.append('utmsource', document.querySelector('#utm_source_company').value);
                    data.append('utmmedium', document.querySelector('#utm_medium_company').value);
                    data.append('utmcampaign', document.querySelector('#utm_campaign_company').value);
                    data.append('utmextra', document.querySelector('#utm_campaign_info_b_company').value);
                    const urlB = template.mcint
                    const headerB = {
                        method: 'POST',
                        //headers: { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryeBs6lzForh8BEn4Y' },
                        mode: 'cors',
                        cache: 'default',
                        redirect: 'follow',
                        referrerPolicy: 'no-referrer',
                        body: data
                    };
                    fetchApiMailchimp(urlB, headerB)
                        .then(response => {
                            if (response.status !== 400) {
                                //console.log(response);
                                let pageType = document.querySelector('#page-type').value;
                                dataLayer.push({
                                    'pageType': pageType,
                                    'formName': 'Form contacto empresa',
                                    'event': 'Lead Confirmed'
                                });
                            } else {
                                //console.log(response);
                            }
                        })


                    let slctCargo = $('#slct-cargo-text'),
                        slctNw = $('#slct-nw-text'),
                        textArea = $('.mdc-text-field--textarea');
                    slctCargo.text('');
                    slctNw.text('');
                    slctCargo.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    slctNw.parent().find('#demo-label').removeClass('mdc-floating-label--float-above');
                    textArea.find('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    $('.mdc-floating-label').removeClass('mdc-floating-label--float-above');
                    
                   
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                        $('#form-company').find('.fusion-alert').attr('style', 'display:none;');
                        $('.modal-company').attr('style', 'display:none;');
                        $('#gracia-2').attr('style', 'display:block;');                      
                        $('.contact-modal-empresa').on('hidden.bs.modal', function (event) {                            
                            $('.contact-modal-empresa').find('#b-cerrar').attr('style', 'display:block;');
                            $('#form-company').attr('style', 'display:block;');
                            $('#gracia-2').attr('style', 'display:none;');
                            $('#form-company').find('.fusion-alert').attr('style', 'display:none;');
                        })

                    }, 3500);
                } else {
                    event.preventDefault();
                    let btnSendcompany = $('#sendFormCompany');
                    btnSendcompany.removeAttr('disabled');
                    let inputInvalidResponse = event.detail.apiResponse.invalid_fields;
                    
                    if(inputInvalidResponse != null) {
                        for (const input of inputInvalidResponse) {
                            let inputElement = document.querySelector(`#${input.idref}`),
                                inputElementHelperText = document.querySelector(`#${input.idref}-helper-text`);
                            
                            inputElement.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                            inputElement.focus();
                            inputElementHelperText.innerText = input.message;
                        }
                        // select
                        let valueSlct = document.querySelectorAll('.mdc-select__selected-text-company');
                        for (const element of valueSlct) {
                            if (element.innerText === '') {
                                let id = element.dataset.id,
                                    message = 'El campo es obligatorio';
                                element.parentNode.parentNode.classList.add('mdc-text-field--invalid');
                                element.parentNode.parentNode.nextElementSibling.firstElementChild.innerText = message;
                            }
                        }
                    }
                    setTimeout(() => {
                        $('#form-company').find('.fusion-alert').attr('style', 'display:none;');
                    }, 1500);
                    setTimeout(() => {
                        $('.fusion-slider-loading').attr('style', 'display:none;');
                    }, 8500);
                    return false;
                }
            break;
        
            default:
                // none
                break;
        }
        
    }, false);
    if (document.querySelector('input[type="email"]')) {
        document.querySelector('input[type="email"]').addEventListener('blur', (event) => {
            let email = document.querySelector('input[type="email"]').value;
            if (email !== '') {
                if (!emailIsValid(email)) {
                    document.querySelector('[data-valid="format"]').style.display = 'block';
                    document.querySelector('[data-valid="empty"]').style.display = 'none';
                } else {
                    document.querySelector('[data-valid="format"]').style.display = 'none';
                    document.querySelector('[data-valid="empty"]').style.display = 'block';
                };
            } else {
                document.querySelector('[data-valid="empty"]').style.display = 'block';
                document.querySelector('[data-valid="format"]').style.display = 'none';
            }
    
        });
    }
}
const setAttributeElement = (elements, attr, attrVal) => {
    elements.forEach(el => {
        el.setAttribute(attr, attrVal);
    });
}
const removeAttributeElement = (elements, attr) => {
    elements.forEach(el => {
        el.removeAttribute(attr);
    });
}
const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
const radioWork = document.querySelectorAll('input[name="dis"]');
    radioWork.forEach(item => {
        const valueRadio = item.addEventListener('click', () => {
            let hiddenElements = document.querySelectorAll(".av-hidden-action")
                submit = document.querySelector("#sendWork");
            if(item.value == 'no') {
                document.getElementById("radio-info").style.display = "block";
                document.getElementById("radio-info").style.marginBottom = "2em";
                document.getElementById("radio-info").style.marginBottom = "2em";
                setAttributeElement(hiddenElements, 'style', 'display: none;')
                submit.setAttribute("disabled", true)
            }else {
                document.getElementById("radio-info").style.display = "none";
                document.getElementById("radio-info").style.marginBottom = "6px";
                removeAttributeElement(hiddenElements, 'style')
                submit.removeAttribute("disabled")
            }
    });
});
const input = document.querySelectorAll('.wpcf7-form-control');
    input.forEach(item => {
        const inputText = item.addEventListener('blur', () => {
            if (item.attributes["aria-labelledby"]) {
                let elementHelperError = document.querySelector(`#${item.attributes["aria-labelledby"].value}-helper-text-error`),
                    elementHelperText = document.querySelector(`#${item.attributes["aria-labelledby"].value}-helper-text`);
                if (item.value == '' && elementHelperError && elementHelperText) {
                    elementHelperError.classList.remove('d-none');
                    elementHelperText.classList.add('d-none');
                } else if (elementHelperText && elementHelperError) {
                    elementHelperError.classList.add('d-none');
                    elementHelperText.classList.remove('d-none');
                }
            }
    });
});


window.onload = loadDom;